import React, { useEffect, useState, useRef } from "react";
import "./DocViewer.css";

const DocViewer = () => {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const viewerRef = useRef(null);

  useEffect(() => {
    fetch("/hotworkpermit.html")
      .then((res) => res.text())
      .then((data) => {
        setHtml(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading HTML:", err);
        setLoading(false);
      });
  }, []);

  // Save edited HTML back to state
  const handleInput = () => {
    if (viewerRef.current) {
      setHtml(viewerRef.current.innerHTML);
    }
  };

  if (loading) return <p style={{ color: "white" }}>Loading document...</p>;

  return (
    <div
      ref={viewerRef}
      className="doc-viewer-container"
      contentEditable={true}
      suppressContentEditableWarning={true}
      onInput={handleInput}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default DocViewer;
